import { render } from "./indexV2.vue?vue&type=template&id=21f5b18b&scoped=true"
import script from "./indexV2.vue?vue&type=script&lang=js"
export * from "./indexV2.vue?vue&type=script&lang=js"

import "./indexV2.vue?vue&type=style&index=0&id=21f5b18b&scoped=true&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f5b18b"]])

export default __exports__